import { render, staticRenderFns } from "./timeline-item.vue?vue&type=template&id=5467b9bb&"
import script from "./timeline-item.vue?vue&type=script&lang=js&"
export * from "./timeline-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports